/* global require, module, window */
var Handler = require('./mock/handler')
var Util = require('./mock/util')
var Random = require('./mock/random')
var RE = require('./mock/regexp')
var toJSONSchema = require('./mock/schema')
var valid = require('./mock/valid')

var XHR, MockFetch
if (typeof window !== 'undefined') {
    XHR = require('./mock/xhr')
    MockFetch = require('./mock/fetch')
}

/*!
    Mock - 模拟请求 & 模拟数据
    https://github.com/nuysoft/Mock
    墨智 mozhi.gyy@taobao.com nuysoft@gmail.com
*/
var Mock = {
    Handler: Handler,
    Random: Random,
    Util: Util,
    XHR: XHR,
    RE: RE,
    toJSONSchema: toJSONSchema,
    valid: valid,
    heredoc: Util.heredoc,
    setup: function(settings) {
        return XHR.setup(settings)
    },
    _mocked: {}
}

Mock.version = '1.2.0'

/*
    flag - whether send intercepted request
*/
Mock.sendRequest = false

// 避免循环依赖
if (XHR) XHR.Mock = Mock
if (MockFetch) MockFetch.Mock = Mock

/*
    * Mock.mock( template )
    * Mock.mock( function() )
    * Mock.mock( rurl, template )
    * Mock.mock( rurl, function(options) )
    * Mock.mock( rurl, rtype, template )
    * Mock.mock( rurl, rtype, function(options) )

    根据数据模板生成模拟数据。
*/
Mock.mock = function(rurl, rtype, template) {
    // Mock.mock(template)
    if (arguments.length === 1) {
        return Handler.gen(rurl)
    }
    // Mock.mock(rurl, template)
    if (arguments.length === 2) {
        template = rtype
        rtype = undefined
    }
    // 拦截 XHR
    if (XHR) {
        window.XMLHttpRequest = XHR
        window.fetch = MockFetch
    }
    Mock._mocked[rurl + (rtype || '')] = {
        rurl: rurl,
        rtype: Util.isString(rtype) ? rtype.toLowerCase() : rtype,
        template: template,
        sendRequest: Mock.sendRequest
    }
    return Mock
}

module.exports = Mock



//////////////////
// WEBPACK FOOTER
// ./src/mock.js
// module id = 0
// module chunks = 0